import {Component, computed, inject} from '@angular/core';
import {BaseModalComponent} from "../../../../../../core/components/modals/base-modal/base-modal.component";
import {
  createTestingResultModalName,
  createTestingResultModalTitle
} from "./configs/create-component-config";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatInput, MatLabel} from "@angular/material/input";
import {FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  CreateTestingResulForm,
  CreateTestingResultData,
  CreateTestingResultDialogData
} from "./types/create-testing-result.types";
import {createTestingResultFormFields} from "./configs/create-testing-result-form-fields";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CreateTestingResultService} from "./services/create-testing-result.service";
import {CdkTextareaAutosize} from "@angular/cdk/text-field";

@Component({
  selector: 'app-create-testing-result-modal',
  imports: [
    BaseModalComponent,
    MatButton,
    MatFormField,
    MatLabel,
    MatInput,
    FormsModule,
    ReactiveFormsModule,
    CdkTextareaAutosize
  ],
  templateUrl: './create-testing-result-modal.component.html',
  styleUrl: './create-testing-result-modal.component.scss'
})
export class CreateTestingResultModalComponent extends BaseModalComponent {
  private createTestingResultDialogData = inject<CreateTestingResultDialogData>(MAT_DIALOG_DATA);
  private createTestingResultService: CreateTestingResultService = inject(CreateTestingResultService);

  public readonly createTestingResultModalTitle = createTestingResultModalTitle;
  public readonly createTestingResultFormFields = createTestingResultFormFields;
  public productCardId = computed(() => this.createTestingResultDialogData.productCardId);
  public testingResultForm: FormGroup = new FormGroup({});

  public override ngOnInit(): void  {
    super.ngOnInit();
    this.modalStatesService.openModal(createTestingResultModalName);
    this.testingResultForm = this.baseModalService.getFormGroup<CreateTestingResulForm>(createTestingResultFormFields);
  }

  public override ngOnDestroy(): void {
    super.ngOnDestroy();
    this.modalStatesService.closeModal(createTestingResultModalName);
  }

  public async handleCreate(): Promise<void> {
    const createData: CreateTestingResultData = {
      productCardId: this.productCardId(),
      ...this.testingResultForm.value
    };

    await this.createTestingResultService.createTestingResultData(createData)
      .then(() => this.closeDialog('success'))
      .catch(() => this.closeDialog('cancel'));
  }
}
